module.exports = __webpack_public_path__ + "img/btn-download.98586b73.svg";